import { getCurrentDomain } from '../helpers/browser';

/**
 * Helper function to get a cookie value by its name.
 * @param cname
 * @returns {string}
 */
export const getCookie = (cname: string): any => {
    const name = cname + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1);
        if (c.indexOf(name) === 0) {
            const value = c.substring(name.length, c.length);
            return decodeURIComponent(value);
        }
    }
    return '';
};

/**
 * Helper function to set a cookie value.
 * @param cname
 * @param cvalue
 * @param exdays
 * @param withSubDomain
 * @param isSecure
 */
export const setCookie = (
    cname: string,
    cvalue: any,
    exdays: number,
    withSubDomain = false,
    isSecure = false,
    isSameSite = false
) => {
    if (isSecure && window.location.protocol.indexOf('https') === -1) {
        isSecure = false;
    }
    const d = new Date();
    // cvalue = encodeURIComponent(cvalue);
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = '; expires=' + d.toUTCString();
    if (exdays === 0) {
        expires = '';
    }
    const domain = withSubDomain ? getCurrentDomain(2, '.') : getCurrentDomain(1, '.');
    document.cookie =
        cname +
        '=' +
        cvalue +
        '; path=/' +
        expires +
        '; domain=' +
        domain +
        (isSecure ? '; secure' : '') +
        (isSameSite ? '; SameSite = None' : '');
};

export const deleteCookie = (cname: string, withSubDomain = false) => {
    const domain = withSubDomain ? getCurrentDomain(2, '.') : getCurrentDomain(1, '.');
    document.cookie = `${cname}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain}`;
};
